var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.form)?_c('span',[_vm._v(_vm._s(_vm._f("ififnot")(_vm.condition.mustBe))+" dynamic form '"+_vm._s(_vm.form.title.substring(0, 25))+"'")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }